import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Splide from '@splidejs/splide';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
gsap.registerPlugin(Draggable, ScrollTrigger, ScrollToPlugin);
export var timelineBehavior = function timelineBehavior() {
  Alpine.data('timelineBehavior', function () {
    var timelineBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'blue';
    return {
      $timeline: false,
      $timelineMeta: false,
      $timelineControls: false,
      $subNav: false,
      timelineBackground: timelineBackground,
      panelHeight: '28rem',
      stepsContainer: false,
      steps: [],
      stepOffsets: [],
      stepCount: 0,
      stepWidth: 0,
      currentStep: 1,
      dragger: false,
      animation: false,
      animationDuration: 0.5,
      stepAnimation: false,
      activeStep: 0,
      slider: false,
      timelineContentHeight: 0,
      windowLessThanContent: false,
      init: function init() {
        this.$timeline = this.$el;
        this.$timelineMeta = this.$timeline.querySelector('.o-timeline__meta');
        this.$timelineControls = this.$timeline.querySelector('.o-timeline__controls');
        this.$subNav = document.querySelector('.m-sub-navigation');
        this.initSteps();
        this.initSlider();
      },
      initSteps: function initSteps() {
        this.stepsContainer = this.$timeline.querySelector('.o-timeline__steps');
        this.steps = this.stepsContainer.querySelectorAll('.o-timeline__step');
        this.stepCount = this.steps.length;
      },
      initSlider: function initSlider() {
        var sliderSteps = this.$timeline.querySelector('.o-timeline__slider');
        this.currentStep = 1;
        this.slider = new Splide(sliderSteps, {
          type: 'slide',
          direction: breakpoint.isDesktop ? 'ttb' : 'ltr',
          arrows: false,
          pagination: breakpoint.isTouch ? 'slider' : false,
          perPage: 1,
          perMove: 1,
          interval: 5000,
          gap: breakpoint.isTouch ? '1rem' : 0,
          drag: breakpoint.isTouch,
          destroy: 'completely',
          autoHeight: true,
          heightRatio: 1,
          classes: {
            pagination: "splide__pagination o-timeline__pagination o-timeline__pagination--".concat(this.timelineBackground),
            page: "splide__pagination__page o-timeline__pagination-button"
          }
        });
        this.sliderEvents();
        this.slider.mount();
      },
      sliderEvents: function sliderEvents() {
        var _this = this;

        this.slider.on('pagination:mounted', function (data) {
          data.items.forEach(function (item) {
            item.li.classList.add('splide__pagination__item', 'o-timeline__pagination-item');
          });
        });
        this.slider.on('pagination:updated', function (data) {
          data.items.forEach(function (item) {
            var slide = item.Slides[0] || false;

            if (slide.isActive()) {
              item.li.classList.add('is-active');
            } else {
              item.li.classList.remove('is-active');
            }
          });
        });
        this.slider.on('moved', function (currentStep) {
          _this.currentStep = currentStep + 1;
        });
      },
      calculatePanelHeight: function calculatePanelHeight() {
        var windowHeight = window.screen.height;
        var timelineStyles = window.getComputedStyle(this.$timeline);
        var timelinePaddingTop = parseInt(timelineStyles.getPropertyValue('padding-top'), 10);
        var timelinePaddingBottom = parseInt(timelineStyles.getPropertyValue('padding-bottom'), 10);
        var timelinePadding = timelinePaddingTop + timelinePaddingBottom;
        var metaDimensions = this.$timelineMeta.getBoundingClientRect();
        var timelineControlsDimensions = this.$timelineControls.getBoundingClientRect();
        this.panelHeight = metaDimensions.height + timelineControlsDimensions.height;
        this.timelineContentHeight = this.panelHeight + timelinePadding;
        this.windowLessThanContent = windowHeight < this.panelHeight + timelinePadding;

        if (this.windowLessThanContent) {
          this.$timeline.classList.remove('lg:max-h-screen');
        } else {
          this.$timeline.classList.add('lg:max-h-screen');
        }
      },
      refresh: function refresh() {
        this.calculatePanelHeight();
        this.refreshSlider();
      },
      refreshSlider: function refreshSlider() {
        if (this.slider) {
          this.slider.destroy();
        }

        this.initSlider();
      },
      timeline: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce.300ms': function resizeWindowStopDebounce300ms() {
          this.refresh();
        },
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.refresh();
        }
      },
      prevStep: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.slider.go('<');
        }
      },
      nextStep: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.slider.go('>');
        }
      }
    };
  });
};